import { AudioPlayer } from '@cp/ds/src/components/audioPlayer';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { DeleteIcon } from '@cp/ds/src/icons/delete';
import React from 'react';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { AUDIO_EXAMPLE_SRC } from '../../../const';

const SaveAudioMessage: React.FC<{ onSave?: () => void; onDelete?: () => void }> = ({ onSave, onDelete }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const actionButton = (
    <Button color="pink" onClick={onSave}>
      Сохранить
    </Button>
  );

  return (
    <>
      <Stack sx={{ position: 'relative', alignItems: 'center', justifyContent: 'center', mt: { xs: 5, md: 4.375 }, mb: 2.5 }}>
        <AudioPlayer size={isMobile ? 'normal' : 'small'} source={AUDIO_EXAMPLE_SRC} />
        {!isMobile ? (
          <DeleteIcon onClick={onDelete} sx={{ position: 'absolute', cursor: 'pointer', right: -36 }} />
        ) : (
          <Link onClick={onDelete} sx={{ mt: 3 }} underline={false}>
            Удалить
          </Link>
        )}
      </Stack>

      {!isMobile ? (
        actionButton
      ) : (
        <Stack
          sx={{
            position: 'fixed',
            bottom: 0,
            backgroundColor: theme.palette.white,
            pt: 1.5,
            px: 2.5,
            pb: 4.5,
            width: 1,
            boxShadow: '0px -3px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {actionButton}
        </Stack>
      )}
    </>
  );
};

export default SaveAudioMessage;
